var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.159 14.985c0-.996-.09-1.955-.256-2.875H14.666v5.437h7.564a6.466 6.466 0 0 1-2.805 4.242v3.526h4.543c2.657-2.446 4.19-6.05 4.19-10.33Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.666 28.72c3.795 0 6.976-1.258 9.302-3.405l-4.543-3.526c-1.258.843-2.868 1.341-4.76 1.341-3.66 0-6.758-2.472-7.863-5.794H2.106v3.641c2.313 4.594 7.066 7.743 12.56 7.743Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.802 17.336a8.449 8.449 0 0 1-.441-2.67c0-.926.16-1.827.44-2.67V8.354H2.107a14.05 14.05 0 0 0-1.495 6.312c0 2.268.543 4.414 1.495 6.312l4.696-3.642Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.666 6.2c2.063 0 3.916.71 5.373 2.103l4.03-4.032c-2.433-2.267-5.615-3.66-9.403-3.66-5.494 0-10.247 3.15-12.56 7.743l4.696 3.641c1.105-3.322 4.203-5.794 7.864-5.794Z",
    fill: "#EA4335"
  })));
};

export default SvgGoogle;